import React from 'react'
import {
  ButtonTypes,
  Button as CustomButton,
  ButtonProps as CustomButtonProps,
} from '@/baseComponents'
import { ButtonVariants, ButtonSizes } from '@/types/enums'
import { useMultiStyleConfig } from '@chakra-ui/react'

export interface ButtonProps extends CustomButtonProps {
  buttonSize?: ButtonSizes
  buttonVariant?: ButtonVariants
  disableGroupHover?: boolean
}

export const Button = ({
  text,
  icon,
  iconPosition,
  iconProps,
  ariaLabel,
  url,
  target,
  onClick,
  buttonProps,
  buttonType = ButtonTypes.Default,
  buttonVariant = ButtonVariants.Primary,
  buttonSize = ButtonSizes.Small,
  isDownloadLink,
  disableGroupHover = false,
  theme = 'brand',
  ...props
}: ButtonProps) => {
  const styles = useMultiStyleConfig('ButtonConfig', {
    variant: buttonVariant,
    size: buttonSize,
    colorScheme: theme,
    disableGroupHover: disableGroupHover,
  })

  return (
    <CustomButton
      url={url}
      onClick={onClick}
      text={text}
      icon={icon}
      buttonType={buttonType}
      ariaLabel={ariaLabel}
      iconPosition={iconPosition}
      isDownloadLink={isDownloadLink}
      target={target}
      buttonProps={{
        __css: styles.button,
        variant: buttonVariant,
        size: buttonSize,
        ...buttonProps,
      }}
      iconProps={{
        __css: styles.icon,
        'aria-label': `${ariaLabel}`,
        variant: buttonVariant,
        size: buttonSize,
        ...iconProps,
      }}
      {...props}
    />
  )
}
